import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PersonalizedFeaturesApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = PersonalizedFeaturesApiClient;
export const PersonalizedFeaturesExtension = createModuleExtension({
  extensionName: 'personalizedFeaturesExtension',
  Provider,
  SDK: {
    personalizedFeaturesApiClient: client
  }
});
//# sourceMappingURL=personalized-features.extension.js.map